// extracted by mini-css-extract-plugin
export default {"fenLoader":"FENLoader_fenLoader__hf63n"};